'use client';
import React from 'react';
import { MimaButton, MimaText, PageLayout2 } from '@/components';
import styles from '@/assets/styles/pages/home/About.module.scss';
import Image from 'next/image';
import AboutImg from '@/assets/img/pictures/Mima team.jpg';
import Puzzle from '@/assets/img/pictures/jigsaw.jpg';
import { slides } from '@/utils/testimonialData';
import { useMediaQuery } from 'react-responsive';
import Link from 'next/link';
import { DownloadAppBtns } from '../home/_homeComponents/Closer';
import { useRouter } from 'next/navigation';
import constant from '@/utils/constant';
import our_story from '@/assets/img/pictures/our_story.png';
import we_offer from '@/assets/img/pictures/we_offer.png';
import accessibility from '@/assets/img/pictures/accessibility.png';
import global from '@/assets/img/pictures/global.png';
import customizable from '@/assets/img/pictures/customizable.png';
import community from '@/assets/img/pictures/community.png';

const About = () => {
  const whyChooseCard = [
    {
      id: 1,
      img: accessibility,
      lead: 'Affordable & Accessible',
      content: 'We offer competitive fees without compromising on features. No hidden costs, just pure value for your business',
    },
    {
      id: 2,
      img: global,
      lead: 'Global Reach',
      content: 'Our multi-currency wallet and logistics solutions help you take your business international with ease.',
    },
    {
      id: 3,
      img: customizable,
      lead: 'Customizable',
      content: 'Every brand is unique, and we provide the flexibility and tools to help you express your individuality.',
    },
    {
      id: 4,
      img: community,
      lead: 'Supportive Community',
      content:
        "We believe in building strong partnerships and growing together. Our webinars, training sessions, and hands-on support ensure that you're never alone in your journey.",
    },
  ];

  const renderBoldText = (text: string) => {
    const parts = text.split('**');
    return parts.map((part: string, index: number) => {
      if (index % 2 === 0) {
        return part; // Non-bold text
      } else {
        return <strong key={index}>{part}</strong>; // Bold text
      }
    });
  };

  const testimonial = slides.slice(0, 3);

  const isBelow800 = useMediaQuery({
    query: '(max-width: 800px)',
  });

  const router = useRouter();

  const goToSignup = () => {
    router.push(constant.Routes.SignUp);
  };

  return (
    <PageLayout2>
      <section className={styles.container}>
        <MimaText variant="h4Bold" align="center" mt={4}>
          About Us
        </MimaText>
        <MimaText variant="body" align="center" mt={2} mr={4} ml={4}>
          At FashCreatives, we’re on a mission to empower fashion brands, designers, and entrepreneurs by providing them with cutting-edge tools to
          grow, scale, and succeed in the global market. As a fashion tech company, we believe that creativity should be limitless and accessible to
          everyone, no matter where they are in their business journey. 
        </MimaText>
        <div className={styles.about}>
          <div>
            <MimaText variant="h4Bold">Our Story</MimaText>
            <MimaText variant="body" mt={4}>
              FashCreatives was born from a vision to bridge the gap between fashion and technology. We noticed that many existing platforms were
              either too expensive or lacked the features that small and medium-sized businesses needed to truly thrive. So, we created an affordable,
              all-in-one platform that provides everything you need to manage, promote, and scale your fashion business — from website creation to
              global logistics and everything in between.
            </MimaText>
          </div>
          <Image src={our_story} alt="Our Story" className={styles.about__img} />
        </div>
        <div className={styles.about}>
          <Image src={we_offer} alt="What We Offer" className={styles.about__img} />
          <div>
            <MimaText variant="h4Bold">What We Offer</MimaText>
            <MimaText variant="body" mt={4}>
              Our platform offers a wide range of features tailored to the needs of fashion entrepreneurs. From free website creation and style
              management to payment links, customer management, multi-currency wallets, and global logistics solutions — we’ve got you covered.
              Whether you’re a boutique designer, a couture streetwear brand, or an artist looking to expand globally, FashCreatives is your
              partner in turning your vision into a thriving business.
            </MimaText>
          </div>
        </div>

        <div>
          <MimaText variant="h4Bold" align="center" mt={4} mb={4}>
            Why Choose FashCreatives?
          </MimaText>
          <div className={styles.whyChooseUs}>
            {whyChooseCard.map((item) => (
              <div key={item.id} className={styles.whyChooseUs_content}>
                <Image src={item.img} alt={item.lead} width={100} />
                <MimaText variant="bodyBold" mb={1} mt={1}>
                  {item.lead}
                </MimaText>
                <MimaText variant="small">{item.content}</MimaText>
              </div>
            ))}
          </div>
        </div>

        <div className={styles.about}>
          <div>
            <MimaText variant="h4Bold">Our Vision</MimaText>
            <MimaText variant="body" mt={4}>
              We strive to create a future where every fashion brand, no matter its size, has the opportunity to shine on a global stage. We are
              passionate about providing fashion businesses with the tools they need to succeed, and we’re constantly innovating to bring you the best
              solutions to your business challenges.
            </MimaText>
          </div>
          <Image src={our_story} alt="Our Story" className={styles.about__img} />
        </div>
        <div className={styles.join}>
          Join the FashCreatives family and take your fashion business to the next level. Let’s create, grow, and thrive together!
        </div>
      </section>
    </PageLayout2>
  );
};

export default About;
